import { CardNumberChallengeItem } from '@varo/graphql-schema-types';
import React, { createContext, useCallback, useContext, useState } from 'react';

interface CardCredentialChallengeContextValue {
  challenges: CardNumberChallengeItem[];
  loadChallenges: (challenges: CardNumberChallengeItem[]) => void;
  clearChallenges: () => void;
}

const defaultValue: CardCredentialChallengeContextValue = {
  challenges: [],
  loadChallenges: () => undefined,
  clearChallenges: () => undefined,
};

export const CardCredentialChallengeContext =
  createContext<CardCredentialChallengeContextValue>(defaultValue);

export const CardCredentialChallengeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [challenges, setChallenges] = useState<CardNumberChallengeItem[]>([]);

  const loadChallenges = useCallback(
    (c: CardNumberChallengeItem[]) => setChallenges(c),
    [],
  );
  const clearChallenges = useCallback(() => setChallenges([]), []);

  return (
    <CardCredentialChallengeContext.Provider
      value={{ challenges, loadChallenges, clearChallenges }}
    >
      {children}
    </CardCredentialChallengeContext.Provider>
  );
};

export const useCardCredentialChallengeContext =
  (): CardCredentialChallengeContextValue => {
    const ctx = useContext(CardCredentialChallengeContext);
    if (__DEV__ && ctx === defaultValue) {
      console.warn(
        'useCardCredentialChallengeContext called outside CardCredentialChallengeProvider',
      );
    }
    return ctx;
  };
